module.exports = __webpack_public_path__ + "static/media/data.a23431c5.svg";